import { useRef } from 'react';
export const useFocus = () => {
    const ref = useRef(null);
    const focusElement = () => {
        requestAnimationFrame(() => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    };
    return [ref, focusElement];
};
//# sourceMappingURL=useFocus.js.map